<geaui-button-v3 [size]="'small'" (click)="togglePopover($event)" type="secondary">
  <div class="flex gap-2 align-items-center">
    {{ activeWorktree || 'Workspace' }}
    <i class="pi" [class.pi-chevron-down]="!isOpen()" [class.pi-chevron-up]="isOpen()"></i>
  </div>
</geaui-button-v3>
<p-popover
  #workspacePopoverRef
  (onShow)="isOpen.set(true)"
  (onHide)="resetOnClose()"
  appendTo="body"
  styleClass="no-arrow-popover workspace-popover">
  <div class="workspace-popover-content">
    <div class="workspace-popover-header">
      <span class="gea-font-heading-20">Manage Workspaces</span>
      <i class="pi pi-times workspace-popover-close" (click)="hidePopover()"></i>
    </div>

    <div class="workspace-section">
      <div class="workspace-section-title gea-font-heading-20">Add Workspace</div>
      <div class="workspace-add-row">
        <geaui-input-v3
          class="workspace-name-input"
          [id]="'workspaceName'"
          [placeholder]="'Workspace Name'"
          [formGroupInput]="workspaceForm"
          [formFieldName]="'name'">
        </geaui-input-v3>
        <button
          class="workspace-round-btn"
          [class.workspace-round-btn-active]="workspaceForm.valid && !isCreatingWorkspace"
          [disabled]="workspaceForm.invalid || isCreatingWorkspace"
          (click)="addWorkspace()"
          type="button">
          <i class="pi pi-plus"></i>
        </button>
      </div>
    </div>

    <div class="workspace-section workspace-remote-section">
      <div class="workspace-divider">
        <span class="gea-font-heading-16">or choose remote Workspace</span>
      </div>
      <div class="workspace-add-row">
        <geaui-select-v2
          class="workspace-remote-select"
          [options]="remoteWorkspaceOptions"
          [selected]="selectedRemoteWorkspace"
          [label]="'Select Remote Workspace'"
          [disabled]="true">
        </geaui-select-v2>
        <button class="workspace-round-btn" [disabled]="true" type="button">
          <i class="pi pi-plus"></i>
        </button>
      </div>
    </div>

    <div class="workspace-section workspace-my-workspaces-section">
      <div class="workspace-section-title gea-font-heading-20">My Workspaces</div>
      <div class="workspace-list">
        @if (isLoadingWorkspaces) {
          @for (num of [1, 2, 3, 4, 5]; track num) {
            <div class="workspace-list-item">
              <p-skeleton width="60%" height="1.125rem"></p-skeleton>
              <div class="workspace-actions">
                <p-skeleton width="1.125rem" height="1.125rem"></p-skeleton>
                <p-skeleton width="1.125rem" height="1.125rem"></p-skeleton>
              </div>
            </div>
          }
        } @else {
          @for (workspace of displayWorkspaces; track workspace.worktree) {
            <div class="workspace-list-item" (click)="onSelectWorkspace(workspace.worktree)">
              <div class="workspace-name-group">
                <span
                  class="workspace-name gea-font-body-16"
                  [class.workspace-name-active]="workspace.worktree === activeWorktree">
                  {{ workspace.worktree }}
                </span>
                @if (workspace.repositoryKey) {
                  <span class="workspace-repository gea-font-body-12">
                    {{ repositoryDisplayName(workspace.repositoryKey) || workspace.repositoryKey }}
                    @if (repositoryDisplayName(workspace.repositoryKey)) {
                      <span>({{ workspace.repositoryKey }})</span>
                    }
                  </span>
                } @else {
                  <span class="workspace-repository workspace-repository-unbound gea-font-body-12">Unbound repository</span>
                }
              </div>
              <div class="workspace-actions">
                <i class="pi pi-clone" (click)="startCopyWorkspace(workspace.worktree); $event.stopPropagation()"></i>
                @if (deletingWorkspace === workspace.worktree) {
                  <i class="pi pi-spin pi-spinner"></i>
                } @else {
                  <i
                    class="pi pi-trash"
                    [class.disabled]="isDeleteDisabled(workspace.worktree)"
                    (click)="onDeleteWorkspaceClick(workspace.worktree); $event.stopPropagation()"></i>
                }
              </div>
            </div>
            @if (workspace.worktree === copyingWorkspace()) {
              <div class="workspace-list-item workspace-copy-row" (click)="$event.stopPropagation()">
                <geaui-input-v3
                  class="workspace-copy-input"
                  [id]="'copyWorkspaceName'"
                  [formGroupInput]="copyWorkspaceForm"
                  [formFieldName]="'name'"
                  (focusOut)="cancelCopyWorkspace()"
                  (keyUpEnter)="confirmCopyWorkspace(workspace.worktree)">
                </geaui-input-v3>
                <div class="workspace-actions">
                  <i
                    class="pi pi-check"
                    [class.disabled]="copyWorkspaceForm.invalid || isCopyingWorkspace"
                    (mousedown)="$event.preventDefault()"
                    (click)="confirmCopyWorkspace(workspace.worktree)"></i>
                  <i class="pi pi-times" (mousedown)="$event.preventDefault()" (click)="cancelCopyWorkspace()"></i>
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
</p-popover>
